import React from 'react';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';

import { cfPath } from '../../utilities/UrlPaths';
import EnterPassword from './EnterPassword';
import RequestLink from './RequestLink';

const queryParams = new URLSearchParams(window.location.search);
const jwtValue = queryParams.get('jwt', '');
const isResetPage = (jwtValue);
const isRequestPage = window.location.search === '';

const PasswordReset = () => (
  <Container className="mt-4 pt-2 pb-5">
    <Row>
      <Col xs={12}>
        <div id="header" className="mb-4">
          <a id="logo" href={`${cfPath()}/al/index.cfm`}>
            <img
              className="logo"
              src="https://www.invaluableauctions.com/images/af-inv-az.png"
              alt="InvaluableAuctions"
              width="525px"
              aria-label="Invaluable Auctions homepage"
            />
          </a>
        </div>
      </Col>
    </Row>

    {isResetPage
      && (
        <EnterPassword jwtValue={jwtValue} />
      )}
    {isRequestPage
      && (
        <RequestLink />
      )}

  </Container>
);

export default PasswordReset;
